export const CLEVERLINK_API_BASE_URL = '/api'
export const RESOURCES = {
  CONSULTANTS: 'consultants',
  EXPERIENCES: 'experiences',
  CERTIFICATIONS: 'certifications',
  LANGUAGE_LEVELS: 'languageLevels',
  SKILLS: 'skills',
}

export const HTTP_GET_FILTERS = {
  OFFSET: 'offset',
  LIMIT: 'limit',
}

export const HTTP_GET_FILTER_DEFAULT_VALUES = {
  [HTTP_GET_FILTERS.OFFSET]: 0,
  [HTTP_GET_FILTERS.LIMIT]: 10,
}
